var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"40bd0ae84266be2ba5803e19d52ed57ae8df1bac"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["guidr@guidr-llc"]={id:"40bd0ae84266be2ba5803e19d52ed57ae8df1bac"};
      